"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var elog = require("./elog");
var ttiPolyfill;
if (window.document) {
    /* eslint-disable global-require */
    ttiPolyfill = require('tti-polyfill');
    require('first-input-delay'); // Global
    /* eslint-disable global-require */
}
var DEFAULT_TIMING_SAMPLE = 0.1;
var MAX_DURATION_MS = 90000;
function convertTags(tags) {
    return Object.keys(tags).map(function (key) { return key + ":" + tags[key]; });
}
var PerformanceTracker = /** @class */ (function () {
    function PerformanceTracker(tags, sample) {
        this.tags = convertTags(tags);
        this.sample = sample;
    }
    PerformanceTracker.prototype.sampleTimings = function () {
        if (Math.random() > this.sample) {
            return;
        }
        this.recordDomTiming();
        this.recordTimeToInteractive();
        this.recordFirstInputDelay();
    };
    PerformanceTracker.prototype.gauge = function (key, value) {
        elog.gauge({
            value: Math.min(value, MAX_DURATION_MS),
            tags: this.tags,
            name: "frontend." + key + ".duration",
        });
    };
    PerformanceTracker.prototype.recordDomTiming = function () {
        var _this = this;
        var timing = window.performance && window.performance.timing;
        if (!timing) {
            return;
        }
        if (timing.loadEventEnd <= timing.navigationStart) {
            // We haven't finished loading yet, try again after executing all 'load' listeners
            window.addEventListener('load', function () {
                setTimeout(_this.sendDomTimings.bind(_this), 0);
            });
            return;
        }
        this.sendDomTimings();
    };
    PerformanceTracker.prototype.sendDomTimings = function () {
        var _a = window.performance.timing, navigationStart = _a.navigationStart, responseEnd = _a.responseEnd, loadEventEnd = _a.loadEventEnd;
        if (loadEventEnd <= navigationStart) {
            return;
        }
        this.gauge('response', responseEnd - navigationStart);
        this.gauge('loaded', loadEventEnd - navigationStart);
    };
    PerformanceTracker.prototype.recordTimeToInteractive = function () {
        var _this = this;
        ttiPolyfill.getFirstConsistentlyInteractive().then(function (tti) {
            if (!tti) {
                return;
            } // unsupported returns null
            _this.gauge('tti', tti);
        });
    };
    PerformanceTracker.prototype.recordFirstInputDelay = function () {
        var _this = this;
        // global from 'first-input-delay'
        if (!window.perfMetrics) {
            return;
        }
        window.perfMetrics.onFirstInputDelay(function (delay, _evt) {
            _this.gauge('inputdelay', delay);
        });
    };
    return PerformanceTracker;
}());
exports.PerformanceTracker = PerformanceTracker;
function sampleTimings(tags, sample) {
    if (sample === void 0) { sample = DEFAULT_TIMING_SAMPLE; }
    new PerformanceTracker(tags, sample).sampleTimings();
}
exports.sampleTimings = sampleTimings;
//# sourceMappingURL=performance_tracker.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/performance_tracker.js
// module id = EFTA
// module chunks = 20 21